import anime from 'animejs';
import { generateID } from '../utils/Utils';

const clickEffect = (() => {
  const config = {
    triggerCN: 'js-clickEffect',
    elementCN: 'clickEffect',
    anim: {
      tolken: false,
      duration: 400,
    },
  };

  const handlePostion = ({ e, trigger }) => {
    const rect = trigger.getBoundingClientRect();
    const rW = rect.width;
    const rH = rect.height;
    const x = e.clientX - rect.left; // x position within the element
    const y = e.clientY - rect.top; // y position within the element

    return {
      width: rW,
      height: rH,
      top: y,
      left: x,
    };
  };

  const handleAnimation = ({ e, trigger, bubble }) => {
    // get element measurements
    const position = handlePostion({ e, trigger });

    // calculate how big the circle radius should be
    // get the diagonale with Pythagore's formula
    const A2 = parseFloat(position.height) ** 2;
    const B2 = parseFloat(position.width) ** 2;
    const radius = Math.sqrt(A2 + B2);

    anime({
      targets: bubble,
      width: radius * 2,
      height: radius * 2,
      duration: config.anim.duration,
      opacity: [{
        value: 0.1,
        duration: config.anim.duration * 0.98,
      }, {
        value: 0,
        duration: config.anim.duration,
      }],
      easing: [0.25, 1, 0.85, 1],
      complete() {
        // animation has completed
        // remove bubble from DOM
        bubble.parentNode.removeChild(bubble);
      },
    });
  };

  const renderBubble = ({ e, trigger }) => {
    const ID = generateID();
    const postion = handlePostion({ e, trigger });
    // create markup with unique ID and mouse position
    const bubbleMarkup = `<span
                            class="clickEffect__bubble"
                            id="${ID}"
                            style="top:${postion.top}px; left:${postion.left}px;"></span>`;
    // insert markup in trigger
    trigger.insertAdjacentHTML('beforeend', bubbleMarkup);
    // return bubble DOM element
    return document.getElementById(ID);
  };

  const handleClick = ({ e, trigger }) => {
    const bubble = renderBubble({ e, trigger });
    // add class to element for CSS styling
    trigger.classList.add(config.elementCN);

    handleAnimation({ e, trigger, bubble });
  };

  const build = () => {
    // attach element to body so the effect will occur also for elements dynamically created
    document.body.addEventListener('click', (e) => {
      const target = e.srcElement;
      const tag = target.tagName.toLowerCase();
      // check if it's a link or a button (otherwise classList is applied to all elements)
      if (tag === 'button' || tag === 'a') {
        if (target.classList.contains(config.triggerCN)) {
          handleClick({ e, trigger: target });
        }
      }
    });
  };

  const init = () => {
    build();
  };

  return {
    init,
  };
})();

export default clickEffect.init();
